import { useState } from "react";
import { useTranslation } from "react-i18next";
import TitleDescription from "../../../../components/newMotorPolicy/titleDescription/titleDescription";
import useLanguageTranslate from "../../../../hooks/useLanguageTranslate";
import usePolicyCancellationFlow from "../../../../hooks/usePolicyCancellationFlow";
import useValidation from "../../../../hooks/useValidation";
import BottomLayout from "../../../motorInsurancePages/policyOverview/managePolicy/policyCancellationFlow/bottomLayout";
import PolicyCancellationMotorLayout from "../../../motorInsurancePages/policyOverview/managePolicy/policyCancellationFlow/policyCancellationMotorLayout";
import { DomesticHelperCancellationReasons } from "../../../motorInsurancePages/policyOverview/managePolicy/policyCancellationFlow/data";

const DomesticHelperCancellationReasonPage = ({
  handleNavigationToPolicyOverview,
  selectedReason,
  setSelectedReason,
}) => {
  const { handleNextSubstep, handlePrevStep } = usePolicyCancellationFlow();
  const translate = useLanguageTranslate();

  const [selectedReasonState, setSelectedReasonState] = useState(
    selectedReason || ""
  );
  const [otherReason, setOtherReason] = useState("");
  const { errors, validateFields } = useValidation();

  const validationConfig = [
    { name: "selectedReasonState", validations: ["required"] },
    {
      name: "otherReason",
      validations: selectedReasonState == "Others" ? ["required"] : [],
    },
  ];

  const handleRadioChange = (reason) => {
    setSelectedReasonState(reason);
    setSelectedReason(reason);
    if (reason != "Others") {
      setOtherReason("");
    }
  };

  const { t } = useTranslation();

  const continueClickHandler = (e) => {
    console.log("Reason for cancellation: ", selectedReasonState, otherReason);

    e.preventDefault();

    const isFormValid = validateFields(validationConfig, {
      selectedReasonState,
      otherReason,
    });
    if (!isFormValid) {
      return;
    }

    handleNextSubstep();
  };

  return (
    <PolicyCancellationMotorLayout
      btn_onClick={continueClickHandler}
      btn_label={translate("Continue", "التالي")}
      backClickHandler={handlePrevStep}
      CancellationAdditionalComponent={
        <BottomLayout
          btn_onClick={continueClickHandler}
          btn_label={translate("Continue", "التالي")}
          handleNavigationToPolicyOverview={handleNavigationToPolicyOverview}
        />
      }
    >
      <div className="flex flex-col items-center mx-auto max-w-lg max767:p-5 max767:mb-8 max767:pt-0 max767:pb-[160px] pt-[1%]">
        <div className="flex justify-center items-center w-full  pb-20">
          <div className=" p-0 w-full ">
            <TitleDescription
              title={translate("Reason for Cancellation", "سبب الإلغاء")}
              description={translate(
                "Please select the reason for cancelling your domestic helper policy.",
                "ساعدنا في فهم سبب رغبتك في إلغاء سياسة التأمين الخاصة بك. إن ملاحظاتك قيّمة وسيتم استخدامها لتحسين خدماتنا."
              )}
            />

            <form className="space-y-4">
              {DomesticHelperCancellationReasons?.map((reason, index) => {
                const isSelected = selectedReasonState === reason?.label;
                const translatedLabel = translate(
                  reason?.label,
                  reason?.label_ar
                );

                return (
                  <div
                    key={index}
                    onClick={() => handleRadioChange(reason?.label)}
                    className={`flex justify-start items-center gap-4 self-stretch border px-4 py-3 rounded-[10px] border-solid cursor-pointer transition-all hover:border-[#00719A] hover:bg-[#E3F8FF] ${
                      isSelected
                        ? "border-[#00719A] bg-[#E3F8FF]"
                        : "border-[#DDE2E4] bg-[#FFFFFF]"
                    }`}
                  >
                    <input
                      type="radio"
                      name="cancellationReason"
                      id={`reason-${index}`}
                      value={reason?.label}
                      checked={isSelected}
                      onChange={() => handleRadioChange(reason?.label)}
                      onClick={(e) => e.stopPropagation()}
                      className="size-5 text-blue-600 border-gray-300 cursor-pointer !outline-none"
                    />
                    <div className="flex flex-col w-full">
                      <label
                        htmlFor={`reason-${index}`}
                        className="text-[#1A2024] text-lg not-italic font-semibold leading-6 tracking-[-0.18px] mb-0.5 cursor-pointer"
                      >
                        {translatedLabel}
                      </label>

                      {selectedReasonState == "Others" &&
                      reason.label == "Others" ? (
                        <div
                          className="w-full"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <input
                            type="text"
                            placeholder={translate(
                              "Other reasons (please specify)",
                              "أسباب أخرى (يرجى التحديد)"
                            )}
                            value={otherReason}
                            onChange={(e) => setOtherReason(e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                            className="w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder:text-black placeholder:text-lg placeholder:not-italic placeholder:font-normal placeholder:leading-[26px] placeholder:tracking-[-0.18px] placeholder:opacity-50"
                          />
                          {errors.otherReason && (
                            <p className="text-red-500 text-sm">
                              {translate(
                                "Please specify other reason.",
                                "يرجى تحديد سبب آخر"
                              )}
                            </p>
                          )}
                        </div>
                      ) : (
                        <p className="text-[#1A2024] text-base not-italic font-normal leading-6 tracking-[-0.16px]">
                          {translate(
                            reason?.description,
                            reason?.description_ar
                          )}
                        </p>
                      )}
                    </div>
                  </div>
                );
              })}
              {errors.selectedReasonState && (
                <p className="text-red-500 text-sm">
                  {translate(
                    "Please select any reason to proceed.",
                    "يرجى اختيار أي سبب للمتابعة."
                  )}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </PolicyCancellationMotorLayout>
  );
};

export default DomesticHelperCancellationReasonPage;
